// extracted by mini-css-extract-plugin
export default {"ModalOverlay":"modal-overlay_ModalOverlay__GWq-D"};